"use strict";

exports.__esModule = true;
exports["default"] = exports.HDITwoColumn = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _container = _interopRequireDefault(require("../../legacy/container"));

var _components = require("../../components");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Pretitle = _styledComponents["default"].span.withConfig({
  displayName: "hdi-two-column__Pretitle",
  componentId: "sc-1xv7dk9-0"
})(["text-transform:uppercase;letter-spacing:4px;"]);

var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,
  // Background Image url
  backgroundImage: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.string), _propTypes.string]),

  /** setting for bottom padding amount * */
  bottomUnitPadding: _propTypes.number,
  // Child components for grid
  children: _propTypes.node,
  // Container class name
  className: _propTypes.string,

  /** setting for column sizes * */
  columnPropotions: _propTypes.string,

  /** Custom Background React component  */
  customBackground: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string, _propTypes.object]),

  /** A boolean to set whether the dark version of the cta is used */
  darkUi: _propTypes.bool,

  /** Description text usually a text, but can be a React component  */
  description: _propTypes.node,
  // Container component html id
  htmlId: _propTypes.string,

  /** Image content, usually a React component */
  image: _propTypes.node,

  /** The source of an image to display for panel content */
  imageAbove: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** The source of an image to display for panel content */
  imageBelow: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Pretitle text text usually a text, but can be a React component  */
  pretitle: _propTypes.node,

  /** Text position  * */
  textPosition: _propTypes.string,
  // Theme config for grid
  theme: _utils.themePropType,

  /** Title text text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** setting for top padding amount * */
  topUnitPadding: _propTypes.number
};
var defaultProps = {
  bottomUnitPadding: 2,
  columnPropotions: "one-half",
  textPosition: "left",
  topUnitPadding: 2
};

var HDITwoColumn = function HDITwoColumn(_ref) {
  var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      bottomUnitPadding = _ref.bottomUnitPadding,
      topUnitPadding = _ref.topUnitPadding,
      children = _ref.children,
      className = _ref.className,
      columnPropotions = _ref.columnPropotions,
      customBackground = _ref.customBackground,
      description = _ref.description,
      pretitle = _ref.pretitle,
      title = _ref.title,
      darkUi = _ref.darkUi,
      image = _ref.image,
      imageAbove = _ref.imageAbove,
      imageBelow = _ref.imageBelow,
      htmlId = _ref.htmlId,
      theme = _ref.theme,
      textPosition = _ref.textPosition;
  var textColumns = {
    "one-half": [6, 8, 6],
    "one-third": [6, 8, 4],
    "one-whole": [6, 8, 12],
    "two-thirds": [6, 8, 8]
  };
  var imageColumns = {
    "one-half": [6, 8, 6],
    "one-third": [6, 8, 8],
    "one-whole": [6, 8, 12],
    "two-thirds": [6, 8, 4]
  };
  var descriptionFont = {
    color: darkUi ? "text-light" : "text",
    fontSize: [4, 4, 4, 4, 5, 5],
    fontWeight: 1,
    lineHeight: [2, 3, 3, 3, 2, 2]
  };
  var pretitleFont = {
    color: darkUi ? "text-light" : "legal-grey",
    fontSize: [2, 3],
    fontWeight: 1,
    lineHeight: 3,
    mb: [1, 2, 2, 2, 3]
  };
  var titleFont = {
    color: darkUi ? "text-light" : "text-title",
    fontSize: [8, 9, 10, 10, 11],
    fontWeight: 2,
    lineHeight: [2, 2, 1, 1, 1, 1],
    mb: [1, 2, 3]
  };
  var defaultBg = darkUi ? "background-dark" : "background";
  var desktopDirectionColumns = textPosition === "left" ? "row" : "row-reverse";
  var desktopDirectionRows = textPosition === "left" ? "column" : "column-reverse";
  var desktopDirection = columnPropotions === "one-whole" ? desktopDirectionRows : desktopDirectionColumns;
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, {
    backgroundColor: backgroundColor || defaultBg,
    backgroundImage: backgroundImage,
    className: className,
    htmlId: htmlId,
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_container["default"], {
    alignItems: "center",
    justifyContent: "center",
    maxWidth: 1440,
    px: 0
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    flexDirection: ["column-reverse", "column-reverse", desktopDirection],
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    })
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "flex-start",
    columns: textColumns[columnPropotions],
    flexDirection: "column",
    justifyContent: "flex-start",
    px: [0, 0, "12px", "12px", 2, 2]
  }, /*#__PURE__*/_react["default"].createElement(_components.PanelContent, {
    alignItems: "flex-start",
    description: description,
    descriptionFont: descriptionFont,
    imageAbove: imageAbove,
    imageBelow: imageBelow,
    imageSpacing: [1, 2, 4],
    justifyContent: "flex-start",
    pretitle: pretitle && /*#__PURE__*/_react["default"].createElement(Pretitle, null, pretitle),
    pretitleFont: pretitleFont,
    title: title,
    titleFont: titleFont
  }), children), image && /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "center",
    columns: imageColumns[columnPropotions],
    justifyContent: "center",
    mb: textPosition === "left" ? [5, 5, 0, 0, 0] : [0],
    mt: textPosition === "right" ? [5, 5, 0, 0, 0] : [0],
    px: [0, 0, 2],
    py: columnPropotions === "one-whole" ? 4 : 0
  }, image))));
};

exports.HDITwoColumn = HDITwoColumn;
HDITwoColumn.propTypes = propTypes;
HDITwoColumn.defaultProps = defaultProps;
HDITwoColumn.displayName = "Modules.HDITwoColumn";

var _default = (0, _styledComponents.withTheme)(HDITwoColumn);

exports["default"] = _default;